<template>
  <div id="container">
    <div
      v-if="!mobile"
      class="q-pa-xs items-center justify-center row col-12"
      id="desktop"
    >
      <main class="base">
        <header class="row headerBase">
          <q-img
            v-if="$store.state.autenticacao.logo.logoImpressao"
            :src="$store.state.autenticacao.logo.logoImpressao"
            alt="Logo"
            class="logo q-pl-sm"
            fit="contain"
            crossorigin="*"
          />
          <q-img
            v-else
            fit="contain"
            src="../../../assets/MULTPEX_VETOR.png"
            alt="Acciona Logo"
            class="logo q-pl-sm"
            crossorigin="*"
          />

          <p class="text-h6 text-bold q-pa-md titulo-ficha">
            {{
              dadosCustumizados
                ? dadosCustumizados.titulo
                : "FICHA DE RESPONSABILIDADE"
            }}
          </p>
        </header>
        <div class="row justify-center subHeader">
          {{ dadosCustumizados ? dadosCustumizados.subtitulo : "" }}
        </div>

        <div class="row q-pl-sm justify-center descricao">
          {{ dadosCustumizados ? dadosCustumizados.dizeres : "" }}
        </div>
        <div class="row data1 border-botom">
          <p class="q-pl-sm nome text-bold row items-center">
            NOME: {{ dadosUsuario ? dadosUsuario.nome : "" }}
          </p>
          <p class="q-pl-sm função text-bold row items-center">
            MATRICULA: {{ dadosUsuario ? dadosUsuario.id : "" }}
          </p>
        </div>
        <div class="row data1">
          <div
            style="width: 35%"
            class="q-pl-sm borderleft text-bold row items-center"
          >
            <p>
              DATA DE ADMISSÃO:
              {{
                funcionarioDado?.dataAdmissao
                  ?.split(" ")[0]
                  ?.split("-")
                  ?.reverse()
                  ?.join("/")
              }}
            </p>
          </div>
          <div style="width: 25%" class="q-pl-sm text-bold row items-center">
            <p>CARGO: {{ funcionarioDado?.cargo }}</p>
          </div>
          <div class="q-pl-sm col função text-bold row items-center">
            <p>GHE: {{ funcionarioDado?.funcao }}</p>
          </div>
        </div>
        <div class="row data2 border-botom">
          <div class="row DESCRIÇÃODOMATERIAL text-bold borderleft">
            <p style="width: 50%" class="row justify-center">CODIGO</p>

            <p style="width: 50%" class="row justify-center codigo3">
              DESCRIÇÃO DO MATERIAL
            </p>
          </div>
          <div class="column col ENTREGA">
            <p class="row justify-center border-botom text-bold borderRight">
              ENTREGA
            </p>
            <div class="row">
              <div class="table1 borderRight">
                <p class="text text-bold">Nº DO PATRIMÔNIO</p>
              </div>
              <div class="table2 borderRight">
                <p class="text text-bold">ASSINATURA</p>
              </div>
              <div class="table3 borderRight">
                <p class="text text-bold">UNIDADE DE ENTREGA</p>
              </div>
              <div class="table4 borderRight">
                <p class="text text-bold">DATA ENTREGA</p>
              </div>
            </div>
          </div>
          <div class="column DEVOLUÇÃO">
            <p class="row justify-center border-botom text-bold">DEVOLUÇÃO</p>
            <div class="row">
              <div class="secondTable1 borderRight">
                <p class="text text-bold">Nº DO PATRIMÔNIO</p>
              </div>
              <div class="secondTable2 borderRight">
                <p class="text text-bold">ASSINATURA</p>
              </div>
              <div class="secondTable3 borderRight">
                <p class="text text-bold">DATA ENTREGA</p>
              </div>
              <div class="secondTable4">
                <p class="text text-bold">UNIDADE DEVOLUÇÃO</p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="data3 row border-botom"
          v-for="(tabela, index) in dadosTabela"
          :key="index"
        >
          <div class="row DESCRIÇÃODOMATERIAL borderleft">
            <p style="width: 50%" class="row justify-center">
              {{ tabela ? tabela.codigo : "" }}
            </p>

            <p style="width: 50%" class="row justify-center codigo3">
              {{ tabela ? tabela.descricao : "" }}
            </p>
          </div>
          <div class="ENTREGA borderRight">
            <div class="row" style="height: 100%">
              <div class="table1 borderleft borderRight column">
                <p style="width: 100%" class="text">
                  {{ tabela ? tabela.patrimonio : "" }}
                </p>
              </div>

              <div class="table2 borderleft borderRight column">
                <q-img
                  v-if="
                    tabela.assinaturaRetirada == 'assinatura' ||
                    tabela.assinaturaRetirada == 'biometria'
                  "
                  width="90px"
                  heigth="65px"
                  class="biometria"
                  alt=""
                  fit="contain"
                  crossorigin="*"
                  :src="tabela.conteudoAssinaturaRetirada"
                />

                <p
                  v-else-if="tabela.assinaturaRetirada != null"
                  style="text-align: center"
                >
                  Assinado Eletronicamente
                </p>
              </div>
              <div class="table3 column borderRight">
                <p style="width: 100%" class="text">
                  {{ tabela ? tabela.unidadeRetirada : "" }}
                </p>
              </div>
              <div class="column table4 codigo2">
                <p>
                  {{
                    tabela && tabela.dataRetirada
                      ? tabela.dataRetirada
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      : ""
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="DEVOLUÇÃO">
            <div style="height: 100%" class="row">
              <div
                style="border-right: solid black 1px"
                class="table1 borderleft column"
              >
                <p style="width: 100%" class="text">
                  {{ tabela ? tabela.patrimonio : "" }}
                </p>
              </div>
              <div
                style="border-right: solid black 1px"
                class="secondTable2 borderleft column"
              >
                <q-img
                  v-if="
                    tabela.assinaturaDevolucao == 'assinatura' ||
                    tabela.assinaturaDevolucao == 'biometria'
                  "
                  width="90px"
                  heigth="65px"
                  class="biometria"
                  :src="tabela.conteudoAssinaturaDevolucao"
                  alt=""
                  fit="contain"
                />

                <p
                  v-else-if="tabela.assinaturaDevolucao != null"
                  style="text-align: center"
                  class="text"
                >
                  Assinado Eletronicamente
                </p>
              </div>
              <div style="border-right: 1px solid black" class="column table4">
                <p>
                  {{
                    tabela && tabela.dataDevolucao
                      ? tabela.dataDevolucao
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      : ""
                  }}
                </p>
              </div>
              <div class="secondTable3 column">
                <p style="width: 100%" class="text">
                  {{ tabela ? tabela.unidadeDevolucao : "" }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <div style="overflow: scroll" id="mobile">
      <main id="base-mobile" class="base q-ma-md">
        <header class="row headerBase">
          <q-img
            v-if="$store.state.autenticacao.logo.logoImpressao"
            :src="$store.state.autenticacao.logo.logoImpressao"
            alt="Multpex Logo"
            class="logo q-pl-sm"
            crossorigin="*"
            fit="contain"
          />
          <q-img
            v-else
            src="../../../assets/MULTPEX_VETOR.png"
            alt="Acciona Logo"
            fit="contain"
            class="logo q-pl-sm"
          />

          <p class="text-h6 text-bold q-pa-md titulo-ficha">
            {{
              dadosCustumizados
                ? dadosCustumizados.titulo
                : "FICHA DE RESPONSABILIDADE"
            }}
          </p>
        </header>
        <div class="row justify-center subHeader">
          {{ dadosCustumizados ? dadosCustumizados.subtitulo : "" }}
        </div>

        <div class="row q-pl-sm justify-center descricao">
          {{ dadosCustumizados ? dadosCustumizados.dizeres : "" }}
        </div>
        <div class="row data1 border-botom">
          <p class="q-pl-sm nome text-bold row items-center">
            NOME: {{ dadosUsuario ? dadosUsuario.nome : "" }}
          </p>
          <p class="q-pl-sm função text-bold row items-center">
            MATRICULA: {{ dadosUsuario ? dadosUsuario.id : "" }}
          </p>
        </div>
        <div class="row data1">
          <div
            style="width: 35%"
            class="q-pl-sm borderleft text-bold row items-center"
          >
            <p>
              DATA DE ADMISSÃO:
              {{
                funcionarioDado?.dataAdmissao
                  ?.split(" ")[0]
                  ?.split("-")
                  ?.reverse()
                  ?.join("/")
              }}
            </p>
          </div>
          <div style="width: 25%" class="q-pl-sm text-bold row items-center">
            <p>CARGO: {{ funcionarioDado?.cargo }}</p>
          </div>
          <div class="q-pl-sm col função text-bold row items-center">
            <p>GHE: {{ funcionarioDado?.funcao }}</p>
          </div>
        </div>
        <div class="row data2 border-botom">
          <div class="row column DESCRIÇÃODOMATERIAL borderleft">
            <p style="width: 50%" class="row codigo justify-center text-bold">
              CODIGO
            </p>
            <p class="row descricao2 justify-center text-bold">
              DESCRIÇÃO DO MATERIAL
            </p>
          </div>
          <div class="column col ENTREGA">
            <p class="row justify-center border-botom text-bold borderRight">
              ENTREGA
            </p>
            <div class="row">
              <div class="table1 borderRight">
                <p class="text text-bold">Nº DO PATRIMÔNIO</p>
              </div>

              <div class="table2 borderRight">
                <p class="text text-bold">ASSINATURA</p>
              </div>
              <div class="table3 borderRight">
                <p class="text text-bold">UNIDADE DE ENTREGA</p>
              </div>
              <div class="table4 borderRight">
                <p class="text text-bold">DATA ENTREGA</p>
              </div>
            </div>
          </div>
          <div class="column DEVOLUÇÃO">
            <p class="row justify-center border-botom text-bold">DEVOLUÇÃO</p>
            <div class="row">
              <div class="secondTable1 borderRight">
                <p class="text text-bold">Nº DO PATRIMÔNIO</p>
              </div>
              <div class="secondTable2 borderRight">
                <p class="text text-bold">ASSINATURA</p>
              </div>
              <div class="secondTable3 borderRight">
                <p class="text text-bold">DATA ENTREGA</p>
              </div>
              <div class="secondTable4">
                <p class="text text-bold">UNIDADE DEVOLUÇÃO</p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="data3 row border-botom"
          v-for="(tabela, index) in dadosTabela"
          :key="index"
          :class="{ quebra: index == 5 || (index - 5) % 9 == 0 }"
        >
          <div class="row DESCRIÇÃODOMATERIAL borderleft">
            <p style="width: 50%" class="row justify-center">
              {{ tabela ? tabela.codigo : "" }}
            </p>

            <p style="width: 50%" class="row justify-center codigo3">
              {{ tabela ? tabela.descricao : "" }}
            </p>
          </div>
          <div class="ENTREGA borderRight">
            <div class="row" style="height: 100%">
              <div class="table1 borderleft column">
                <p style="width: 100%" class="text">
                  {{ tabela ? tabela.patrimonio : "" }}
                </p>
              </div>

              <div class="table2 borderleft column">
                <img
                  v-if="
                    tabela.assinaturaRetirada == 'assinatura' ||
                    tabela.assinaturaRetirada == 'biometria'
                  "
                  class="biometria"
                  fit="contain"
                  crossorigin="*"
                  :src="tabela.conteudoAssinaturaRetirada"
                />

                <p
                  v-else-if="tabela.assinaturaRetirada != null"
                  style="text-align: center"
                >
                  Assinado Eletronicamente
                </p>
              </div>
              <div class="table3 column">
                <p style="width: 100%" class="text">
                  {{ tabela ? tabela.unidadeRetirada : "" }}
                </p>
              </div>
              <div class="column table4 codigo2">
                <p>
                  {{
                    tabela && tabela.dataRetirada
                      ? tabela.dataRetirada
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      : ""
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="DEVOLUÇÃO">
            <div style="height: 100%" class="row">
              <div
                style="border-right: solid black 1px"
                class="table1 borderleft column"
              >
                <p style="width: 100%" class="text">
                  {{ tabela ? tabela.patrimonio : "" }}
                </p>
              </div>
              <div
                style="border-right: solid black 1px"
                class="secondTable2 borderleft column"
              >
                <img
                  v-if="
                    tabela.assinaturaDevolucao == 'assinatura' ||
                    tabela.assinaturaDevolucao == 'biometria'
                  "
                  class="biometria"
                  fit="contain"
                  crossorigin="*"
                  :src="tabela.conteudoAssinaturaDevolucao"
                />

                <p
                  v-else-if="tabela.assinaturaDevolucao != null"
                  style="text-align: center"
                  class="text"
                >
                  Assinado Eletronicamente
                </p>
              </div>
              <div style="border-right: 1px solid black" class="column table4">
                <p>
                  {{
                    tabela && tabela.dataDevolucao
                      ? tabela.dataDevolucao
                          .split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      : ""
                  }}
                </p>
              </div>
              <div class="secondTable3 column">
                <p style="width: 100%" class="text">
                  {{ tabela ? tabela.unidadeDevolucao : "" }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
  <q-page-sticky id="mobile" position="bottom-left" :offset="[18, 18]">
    <q-btn
      fab
      icon="download"
      :disable="disable"
      color="blue"
      @click="salvarPdf()"
    />
  </q-page-sticky>
</template>

<script>
import { ref, inject, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { useQuasar } from "quasar";

export default {
  setup() {
    const $route = useRoute();
    const quasar = useQuasar();

    const store = useStore();
    const dados = $route.params.dados;
    const dadosUsuario = ref("");
    const dadosCustumizados = ref();
    const tabelas = ref([]);
    const funcionarioDado = ref({});
    const nome = ref("");
    const funcao = ref("");
    const registro = ref("");
    const dadosTabela = ref("");
    let disable = ref(false);
    const keycloak = inject("keycloak");
    const realm = ref("");
    const quebras = ref([
      9, 22, 35, 48, 61, 74, 87, 100, 113, 126, 139, 152, 165, 178, 191,
    ]);
    const dadosFicha = ref({
      titulo: "",
      subtitulo: "",
      dizeres: "",
    });
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    store.dispatch("pdt/hiddenHeader", false);

    const getNome = async () => {
      realm.value = keycloak.realm;
      tabelas.value = await JSON.parse(dados);
      dadosUsuario.value = await JSON.parse(dados);

      store.dispatch("pdt/hiddenHeader", false);
      getCustumizacao();
    };

    const getCustumizacao = async () => {
      const response = await store.dispatch("ferramentaria/getCautela", {
        unidadeId: dadosUsuario.value?.unidadeConfiguracao,
        unidadeModeloId: store.state.org.unidadeData.id,
        funcionarioId: dadosUsuario.value.matricula,
        emAberto: dadosUsuario.value.emAberto,
        deletado: dadosUsuario.value.deletado,
        dataInicial: dadosUsuario.value.dataInicio
          ? dadosUsuario.value.dataInicio.split("/").reverse().join("-")
          : "",
        dataFinal: dadosUsuario.value.dataTermino
          ? dadosUsuario.value.dataTermino.split("/").reverse().join("-")
          : "",
      });

      dadosCustumizados.value = response.data.resultado.mensagem.fichaCautela;
      funcionarioDado.value = response.data.resultado.mensagem.funcionario;
      dadosTabela.value = response.data.resultado.mensagem.emprestimoCollection;
      if (mobile.value) {
        zoomOut();
      }
    };

    const zoomOut = () => {
      const content = document.getElementById("base-mobile");
      content.style.transform = "scale(0.9)";
      content.style.width = `300%`;
      content.style.height = `100%`;
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const centerX = (windowWidth - content.clientWidth) / 2;
      const centerY = (windowHeight - content.clientHeight) / 2;

      content.style.transformOrigin = "top left";
      content.style.left = centerX + "px";
      content.style.top = centerY + "px";
    };

    const salvarPdf = async () => {
      quasar.notify({
        message: "Aguarde enquanto o PDF é gerado.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      disable.value = true;
      setTimeout(() => {
        dadosTabela.value.forEach((dado) => {
          if (dado.conteudoAssinaturaDevolucao != null) {
            const imagem = new Image();
            imagem.src = dado.conteudoAssinaturaDevolucao;
            imagem.onload = function () {
              console.log("Imagem pré-carregada com sucesso");
            };
            imagem.onerror = function () {
              console.error("Erro ao pré-carregar a imagem");
            };
          }
          if (dado.conteudoAssinaturaRetirada != null) {
            const imagem = new Image();
            imagem.src = dado.conteudoAssinaturaRetirada;
            imagem.onload = function () {
              console.log("Imagem pré-carregada com sucesso");
            };
            imagem.onerror = function () {
              console.error("Erro ao pré-carregar a imagem");
            };
          }
        });
        let data = document.getElementById("base-mobile");
        var hoje = new Date();
        let dataGerado = `${hoje.getDate()}/${hoje.getMonth()}/${hoje.getFullYear()} ${hoje.getHours()}:${hoje.getMinutes()}:${hoje.getMilliseconds()}`;
        html2canvas(data, {
          useCORS: true,
        }).then((canvas) => {
          var imgWidth = 210;
          var pageHeight = 295;
          var imgHeight = (canvas.height * imgWidth) / canvas.width;

          var heightLeft = imgHeight;
          const imgData = canvas.toDataURL("image/jpeg");

          var doc = new jsPDF("p", "mm", "a4", true);
          var position = 10;
          doc.addImage(
            imgData,
            "JPEG",
            10,
            position,
            imgWidth - 15,
            imgHeight + 15
          );
          heightLeft -= pageHeight;

          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(
              imgData,
              "JPEG",
              10,
              position,
              imgWidth - 15,
              imgHeight + 15
            );
            heightLeft -= pageHeight;
          }
          doc.save(`ficha_cautela_${dadosUsuario.value?.nome}_${dataGerado}`);
          disable.value = false;
        });
      }, 0);
    };

    onMounted(() => {
      getNome();
    });

    return {
      tabelas,
      nome,
      zoomOut,
      funcao,
      registro,
      realm,
      quebras,
      disable,
      dadosFicha,
      dadosUsuario,
      dadosCustumizados,
      dadosTabela,
      salvarPdf,
      funcionarioDado,
      mobile,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

@page {
  size: A4 landscape;
}

.base {
  border: 1px solid black;
}

.base p {
  margin: 0px;
}

.descricao {
  border-bottom: 1px solid black;
  min-height: 56px;
  align-items: center;
}

.headerBase {
  border-bottom: 1px solid black;
  display: flex;
}

.border-botom {
  border-bottom: 1px solid black;
}

.separador {
  height: 5px;
  border-bottom: 1px solid black;
}

.função {
  width: 65%;
}

.registro {
  width: 30%;
}

.data2 {
  border-top: 1px solid black;
}

.DESCRIÇÃODOMATERIAL {
  width: 35%;
}

.DESCRIÇÃODOMATERIAL p {
  height: 100%;
  align-items: center;
}

.ENTREGA {
  width: 35%;
}

.DEVOLUÇÃO {
  width: 30%;
}

.unidade-entrega {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.unidade-devolucao {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
}

.borderRight {
  border-right: 1px solid black;
}

.text {
  text-align: center;
  word-wrap: break-word;
}

.table1 {
  display: flex;
  justify-content: center;
  width: 25%;
  align-items: center;
}

.table2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.table3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.codigo3 {
  border-left: 1px solid black;
  border-right: 1px solid black;
}

.table4 {
  display: flex;
  justify-content: center;
  width: 25%;
  align-items: center;
}

.biometria {
  height: 60px !important;
  width: 90px !important;
  object-fit: contain;
}
.secondTable1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.secondTable2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.secondTable3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.secondTable4 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}
.border-top {
  border-top: 1px solid black;
}

.headerBase p {
  width: 79%;
  display: flex;
  justify-content: center;
}

.biometria {
  padding: 6px;

  width: 50px !important;
}

.subHeader {
  border-bottom: 1px solid black;
  font-weight: bolder;
}

.função {
  width: 30%;
  border-left: 1px solid black;
}

.data2 {
  font-size: 11px;
}
.nome {
  width: 60%;
}
.logo {
  margin-top: 5px;
  height: 50px;
  width: 180px;
}

.data3 {
  height: 76px;
  break-inside: avoid;
  page-break-inside: avoid;
}

.quebra {
  page-break-before: always;
  break-before: page;
}
@page {
  margin: 10mm;
  size: 290.7mm 210mm;
}
#desktop {
  display: block;
}
#mobile {
  display: none;
}

/* @media (max-width: 1000px) {
  .base p {
    font-size: 10px;
    margin: 0px;
    padding: 0px;
  }
}
@media (max-width: 800px) {
  .base p {
    font-size: 8px;
    margin: 0px;
    padding: 0px;
  }
} */
@media (max-width: 600px) {
  /* #desktop {
    display: none;
  } */
  #mobile {
    display: block;
  }
}

@media print {
  .data2 {
    font-size: 10px;
  }

  .data3 {
    font-size: 8px;
  }
}
</style>
